import { DatabaseRecord } from "../repos/table.repo";

export interface ElectronicContractModel extends DatabaseRecord {
    requestKey?: string;
    customerType?: ElectronicContractCustomerType;
    customerAppLinked?: boolean;
    documentType?: string;
    providerStatus?: string;
    lastSyncedAt?: string;
    waterUserCode?: string;
    waterUserId?: string;
    waterFactoryId?: string;
    templateId?: string;
    documentId?: string;
    documentCode?: string;
    matBaoCATemplateId?: string;
    status?: string;
    viewUrl?: string;
    signedPdfPath?: string;
    errorMessage?: string;
    createdAt?: string;
    otpSentAt?: string;
    signedAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    customerName?: string;
    customerCode?: string;
    customerPhone?: string;
    customerEmail?: string;
}

export interface CreateElectronicContractModel {
    waterUserCode: string;
    templateId?: string;
    documentType?: string;
    requestKey?: string;
    fieldValues?: Record<string, string>;
}

export type ElectronicContractCustomerType = "CN" | "DN";

export interface ElectronicContractTemplateModel extends DatabaseRecord {
    name: string;
    waterFactoryId?: string;
    waterFactoryName?: string;
    matBaoCATemplateId?: string;
    type?: number;
    matBaoCAConfig?: string | null;
    fieldMapping?: string | null;
    calculatedFields?: string | null;
    status?: string;
    description?: string;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

export interface ElectronicContractFieldDefinition {
    name: string;
    required: boolean;
    source: string;
    format: string;
    allowOverride: boolean;
    requiredWhen?: string | null;
}

export interface ElectronicContractSelectionGroupDefinition {
    name: string;
    fields: string[];
}

export interface ElectronicContractTemplateDefinition {
    documentType: string;
    customerType: ElectronicContractCustomerType;
    signerCount: number;
    customerSignerIndex: number;
    fileName: string;
    generationMode: string;
    canCreateFromTemplate: boolean;
    fields: ElectronicContractFieldDefinition[];
    requiredInputs: string[];
    selectionGroups: ElectronicContractSelectionGroupDefinition[];
}

export interface ElectronicContractPreview {
    templateId: string;
    documentType: string;
    customerType: ElectronicContractCustomerType;
    remoteTemplateId: string;
    generationMode: string;
    canCreateFromTemplate: boolean;
    fields: Record<string, string>;
    customerIdentity: Record<string, string>;
    missingRequiredFields: string[];
}

export interface ElectronicContractSigner {
    signerIndex: number | null;
    signerType: string | null;
    fullName: string | null;
    status: string | null;
}

export interface ElectronicContractLifecycle {
    id: string;
    documentId: string;
    status: string;
    providerStatus: string;
    lastSyncedAt?: string | null;
    signedAt?: string | null;
    companySignState?: string | null;
    companySignAttemptedAt?: string | null;
    requiresReconciliation: boolean;
    signers: ElectronicContractSigner[];
}

export interface ElectronicContractPdf {
    id: string;
    documentId: string;
    providerStatus: string;
    pdfUrl: string;
}

export interface ElectronicContractPdfContent {
    id: string;
    documentId: string;
    providerStatus: string;
    pdfBase64: string;
}

export interface CompanySignElectronicContractModel {
    electronicContractId: string;
    fileContentSignatureImage: string;
}

export interface DemoElectronicContractBootstrapModel {
    connectionProfile: string;
    companyEmail: string;
    surveyEmail: string;
}

export interface DemoElectronicContractBootstrapResult {
    id: string;
    name: string;
    matBaoCATemplateId: string;
    created: boolean;
}

export interface ViewDocumentModel {
    electronicContractId: string;
    type?: number;
}

export interface SendOtpModel {
    electronicContractId: string;
    otpType: number;
    deviceOTP: string;
}

export interface SignDocumentModel {
    electronicContractId: string;
    otpType: number;
    deviceOTP: string;
    codeOTP: string;
    signatureCustomerImage64?: string;
}



export class ElectronicContractModelFactory {
    static getEmpty(): ElectronicContractModel {
        return {
            id: "",
            waterUserCode: "",
            waterUserId: "",
            waterFactoryId: "",
            templateId: "",
            documentId: "",
            documentCode: "",
            matBaoCATemplateId: "",
            status: "",
            viewUrl: "",
            signedPdfPath: "",
            errorMessage: "",
            createdAt: "",
            otpSentAt: "",
            signedAt: "",
            createdBy: "",
            updatedAt: "",
            updatedBy: "",
            customerName: "",
            customerCode: "",
            customerPhone: "",
            customerEmail: ""
        };
    }
}

export class CreateElectronicContractModelFactory {
    static getEmpty(): CreateElectronicContractModel {
        return {
            waterUserCode: "",
            templateId: ""
        };
    }
}
